"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecom = void 0;
var ecom_runtime_1 = require("./ecom.runtime");
Object.defineProperty(exports, "ecom", { enumerable: true, get: function () { return ecom_runtime_1.ecomRuntime; } });
//# sourceMappingURL=index.js.map